<template>
	<div id="">
		年度111
		<share :config="config"></share>
		<!-- <div class="bshare-custom"><a title="分享到QQ空间" class="bshare-qzone"></a><a title="分享到新浪微博" class="bshare-sinaminiblog"></a><a title="分享到人人网" class="bshare-renren"></a><a title="分享到腾讯微博" class="bshare-qqmb"></a><a title="分享到网易微博" class="bshare-neteasemb"></a><a title="更多平台" class="bshare-more bshare-more-icon more-style-addthis"></a><span class="BSHARE_COUNT bshare-share-count">分享</span></div> -->
	</div>
</template>

<script>
	// import Share from 'vue-social-share'
	export default {
		data() {
			return {
				config: {
					url: '', // 网址，默认使用 window.location.href
					source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
					title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
					description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
					image: '', // 图片, 默认取网页中第一个img标签
					sites: ['qzone', 'qq', 'weibo', 'wechat', 'douban'], // 启用的站点
					disabled: ['google', 'facebook', 'twitter'], // 禁用的站点
					wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
					wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>'
				}
			}
		},
		// components: {
		// 	Share
		// }
	}
</script>

<style>
</style>
